<template>
  <div class="update-pwd-container">
    <el-card>
    <div class="update-pwd-title">{{ $t('updatePwd.title') }}</div>
    <el-form ref="pwdForm" :model="form" :rules="rules" label-width="100px" class="update-pwd-form">
      <el-form-item :label="$t('updatePwd.oldPassword.label')" prop="oldPassword">
        <el-input v-model="form.oldPassword" type="password" :placeholder="$t('updatePwd.oldPassword.placeholder')"
          show-password />
      </el-form-item>
      <el-form-item :label="$t('updatePwd.newPassword.label')" prop="newPassword">
        <el-input v-model="form.newPassword" type="password" :placeholder="$t('updatePwd.newPassword.placeholder')"
          show-password />
      </el-form-item>
      <el-form-item :label="$t('updatePwd.confirmPassword.label')" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password"
          :placeholder="$t('updatePwd.confirmPassword.placeholder')" show-password />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{ $t('updatePwd.button') }}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
  </div>
</template>

<script>
// 👇 新增这行,复用现有的角色判定 + 跳 React 逻辑
import { resolveComplaintJump, jumpToComplaintPlatform } from '@/utils/complaintSso'
import { updatePassword } from '@/api/user/loginApi'

export default {
  name: 'UpdatePwd',
  data() {
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('updatePwd.confirmPassword.placeholder')))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: this.$t('updatePwd.oldPassword.placeholder'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t('updatePwd.newPassword.placeholder'), trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.pwdForm.validate(async (valid) => {
        if (valid) {
          try {
            const { code, msg } = await updatePassword({
              oldPwd: this.form.oldPassword,
              newPwd: this.form.newPassword,
              reNewPwd: this.form.confirmPassword
            })
            if (code != 0) {
              this.$message.error(msg)
              return;
            }
                        const user = JSON.parse(localStorage.getItem('user') || '{}')
            user.forceChangePwd = false
            localStorage.setItem('user', JSON.stringify(user))
            const loginContext = JSON.parse(localStorage.getItem('hc_login_context') || '{}')
            if (loginContext && Object.keys(loginContext).length > 0) {
              loginContext.forceChangePwd = false
              localStorage.setItem('hc_login_context', JSON.stringify(loginContext))
            }
            this.$message.success('密码修改成功')
            this.$refs.pwdForm.resetFields()
            // ================================================================
            // 新增:改密成功后,若当前账号属于投诉平台角色(区住建局/市州管理员),直接跳 React
            // 这里复用上方已经解析好的 loginContext(登录原始完整数据,含 token/levelCd/roles) 和 user
            // ================================================================
            const jumpData = (loginContext && Object.keys(loginContext).length > 0) ? loginContext : user
            const username = (loginContext && loginContext.userName) || (user && user.name) || ''
            if (jumpData && resolveComplaintJump(jumpData, username)) {
              console.log('[complaint-change-pwd] 命中投诉平台角色,改密成功后跳 React, username=', username)
              // jumpToComplaintPlatform 会生成 SSO 凭据(含最新 token/角色)并 window.location.href 跳 React
              const jumped = jumpToComplaintPlatform(jumpData, username)
              if (jumped) {
                return // 已触发跨项目跳转,不要再执行 Vue 的 $router.push
              }
            }
            // 非投诉平台角色,走原逻辑跳 Vue 首页
            this.$router.push('/')

            
          } catch (error) {
            this.$message.error(error)
            console.error('修改密码失败:', error)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.update-pwd-container {
  padding: 20px;

  .update-pwd-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .update-pwd-form {
    width: 400px;
    margin: 0 auto;

    .el-form-item {
      margin-bottom: 20px;

      .el-input {
        width: 100%;
      }

      &:last-child {
        margin-bottom: 0;
        text-align: center;

        .el-button {
          width: 120px;
        }
      }
    }
  }
}
</style>
